import { render, staticRenderFns } from "./IntegrationHome.vue?vue&type=template&id=1bc9fd94&"
import script from "./IntegrationHome.vue?vue&type=script&lang=js&"
export * from "./IntegrationHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports